import http from "./http";

// Preferencias do usuario: idioma, produto padrao e quais produtos ele tem. O
// arquivo se chama pelo que entrega, nao por quem responde hoje - `/api/mock` e
// o prefixo do deploy (o `mock_api.py`), e no dia em que outro servico assumir
// muda esta constante e mais nada. `VUE_APP_MOCK_API_URL` acompanha o nome do
// prefixo de proposito: e a variavel que aponta para outra maquina sem tocar
// nos proxies (nginx e devServer), o mesmo par que o `quartixApi.js` usa.
const BASE_URL = process.env.VUE_APP_MOCK_API_URL || "/api/mock";

// O login espera por esta chamada; API pendurada nao pode segurar a tela.
const TIMEOUT_MS = 4000;

export async function fetchUserSettings(email) {
  const { data } = await http.get(`${BASE_URL}/user_settings`, {
    params: { email },
    timeout: TIMEOUT_MS,
  });

  if (!data || data.success !== true) {
    throw new Error((data && data.error) || "user_settings failed");
  }

  return data.data || {};
}
